export function assertNonNullish<TValue>(
	value: TValue,
	message: string = 'Value is null or undefined',
): asserts value is NonNullable<TValue> {
	if (value === null || value === undefined) {
		throw Error(message)
	}
}

export function isNonNullish<TValue>(value: TValue): value is NonNullable<TValue> {
	return value !== null && value !== undefined
}

export function assertIsString(value: unknown, message: string = 'Value is not a string'): asserts value is string {
	if (typeof value !== 'string') {
		throw Error(message)
	}
}
